var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ 'wrapper--no-border': _vm.noBorder }},[_vm._t("default"),(_vm.href)?_c('a',{attrs:{"href":_vm.href,"target":"_blank","rel":"nofollow noopener"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }